window._ = require('lodash');
window.jQuery = window.$ = require('jquery');
window.Backbone = require('backbone');
